import React from "react";
import { useSignal, useComputed } from "@preact/signals-react";
import styles from "./DishRecommendation.module.scss";
import { LoadMoreButton } from "../components/LoadMoreButton/LoadMoreButton";
import { DISPLAY_COUNT } from "../Constant";
import { Img } from "../ImgV2/Img";
import { map } from "lodash";
export function DishRecommendation(props) {
  var dishList = useSignal(props.dish_list.slice(0, DISPLAY_COUNT));
  var showSeeMoreBtn = useComputed(function () {
    return dishList.value.length < props.dish_list.length;
  });
  function seeMore() {
    dishList.value = props.dish_list.slice(0, dishList.value.length + DISPLAY_COUNT);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles.dishRecommendationBox
  }, /*#__PURE__*/React.createElement("header", null, /*#__PURE__*/React.createElement("div", {
    className: styles.title
  }, props.title), /*#__PURE__*/React.createElement("div", {
    className: styles.description
  }, props.description), /*#__PURE__*/React.createElement("div", {
    className: styles.platform
  }, /*#__PURE__*/React.createElement("img", {
    src: props.source.source_icon
  }), /*#__PURE__*/React.createElement("p", null, props.source.source_text))), /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("div", {
    className: styles.listBox
  }, map(dishList.value, function (dish, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.item,
      key: index
    }, /*#__PURE__*/React.createElement(Img, {
      className: "dishRecommendationImg",
      imgKey: dish.dish_image
    }), /*#__PURE__*/React.createElement("div", {
      className: styles.info
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.detail
    }, /*#__PURE__*/React.createElement("p", {
      className: styles.dishName
    }, dish.dish_name), /*#__PURE__*/React.createElement("p", {
      className: styles.dishPrice
    }, dish.dish_price)), /*#__PURE__*/React.createElement("p", {
      className: styles.deliveryTime
    }, dish.dish_delivery_time)));
  })), showSeeMoreBtn.value && /*#__PURE__*/React.createElement(LoadMoreButton, {
    btnText: "More dishes",
    loadMore: seeMore
  })));
}